import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Make jQuery available globally
if (typeof window !== 'undefined') {
  window.jQuery = $;
  window.$ = $;
}

// Initialize Bootstrap tooltips after route update (when page is fully loaded)
export const onRouteUpdate = () => {
  const initTooltips = () => {
    if (typeof window !== 'undefined' && window.jQuery) {
      window.jQuery('[data-toggle="tooltip"]').tooltip('dispose').tooltip();
    }
  };

  // Multiple initialization attempts
  initTooltips();
  setTimeout(initTooltips, 100);
  setTimeout(initTooltips, 500);
  setTimeout(initTooltips, 1000);
};